module.exports = __webpack_public_path__ + "img/iconAvailableOthers.4385f965.png";